import privacyHeroBg from "../assets/privacyhero.png";

function PrivacyPolicy() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${privacyHeroBg})` }}
        aria-labelledby="privacy-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="privacy-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Privacy Policy
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20"
        aria-labelledby="privacy-content-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <article className="rounded-2xl border border-brand/10 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5 sm:p-8 lg:p-10">
            <p className="text-sm text-ink/60">Last updated: May 02, 2026</p>

            <div className="mt-8 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                This Privacy Policy describes Our policies and procedures on the collection, use and
                disclosure of Your information when You use the Service and tells You about Your
                privacy rights and how the law protects You.
              </p>
              <p>
                We use Your Personal data to provide and improve the Service. By using the Service,
                You agree to the collection and use of information in accordance with this Privacy
                Policy.
              </p>
            </div>

            <h2
              id="privacy-content-heading"
              className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl"
            >
              Interpretation and Definitions
            </h2>

            <h3 className="mt-8 text-lg font-semibold text-ink">Interpretation</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              The words of which the initial letter is capitalized have meanings defined under the
              following conditions. The following definitions shall have the same meaning regardless
              of whether they appear in singular or in plural.
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Definitions</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              For the purposes of this Privacy Policy:
            </p>
            <dl className="mt-4 space-y-4 text-base leading-relaxed text-ink/80">
              <div>
                <dt className="font-semibold text-ink">Account</dt>
                <dd className="mt-1">
                  means a unique account created for You to access our Service or parts of our
                  Service.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Company</dt>
                <dd className="mt-1">
                  (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or
                  &quot;Our&quot; in this Privacy Policy) refers to Altus Online School.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Cookies</dt>
                <dd className="mt-1">
                  are small files that are placed on Your computer, mobile device or any other device
                  by a website, containing the details of Your browsing history on that website among
                  its many uses.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Country</dt>
                <dd className="mt-1">refers to: India</dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Device</dt>
                <dd className="mt-1">
                  means any device that can access the Service such as a computer, a cellphone or a
                  digital tablet.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Personal Data</dt>
                <dd className="mt-1">
                  is any information that relates to an identified or identifiable individual.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Service</dt>
                <dd className="mt-1">refers to the Website.</dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Service Provider</dt>
                <dd className="mt-1">
                  means any natural or legal person who processes the data on behalf of the Company.
                  It refers to third-party companies or individuals employed by the Company to
                  facilitate the Service, to provide the Service on behalf of the Company, to perform
                  services related to the Service or to assist the Company in analyzing how the
                  Service is used.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Usage Data</dt>
                <dd className="mt-1">
                  refers to data collected automatically, either generated by the use of the Service or
                  from the Service infrastructure itself (for example, the duration of a page visit).
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Website</dt>
                <dd className="mt-1">
                  refers to the Altus Online School website at{" "}
                  <a
                    href="https://www.altusschool.com"
                    className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
                  >
                    www.altusschool.com
                  </a>
                  .
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">You</dt>
                <dd className="mt-1">
                  means the individual accessing or using the Service, or the company, or other legal
                  entity on behalf of which such individual is accessing or using the Service, as
                  applicable.
                </dd>
              </div>
            </dl>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Collecting and Using Your Personal Data
            </h2>

            <h3 className="mt-8 text-lg font-semibold text-ink">Types of Data Collected</h3>

            <h4 className="mt-6 text-base font-semibold text-ink">Personal Data</h4>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              While using Our Service, We may ask You to provide Us with certain personally
              identifiable information that can be used to contact or identify You. Personally
              identifiable information may include, but is not limited to:
            </p>
            <ul className="mt-4 list-disc space-y-2 pl-6 text-base leading-relaxed text-ink/80">
              <li>Email address</li>
              <li>First name and last name</li>
              <li>Phone number</li>
              <li>Product / Service Interested</li>
            </ul>

            <h3 className="mt-10 text-lg font-semibold text-ink">Use of Your Personal Data</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              The Company may use Personal Data for the following purposes:
            </p>
            <ul className="mt-4 list-disc space-y-3 pl-6 text-base leading-relaxed text-ink/80">
              <li>
                To provide and maintain our Service, including to monitor the usage of our Service.
              </li>
              <li>
                To manage Your Account: to manage Your registration as a user of the Service. The
                Personal Data You provide can give You access to different functionalities of the
                Service that are available to You as a registered user.
              </li>
              <li>
                For the performance of a contract: the development, compliance and undertaking of the
                purchase contract for the products, items or services You have purchased or of any
                other contract with Us through the Service.
              </li>
              <li>
                To contact You: To contact You by email, telephone calls, SMS, or other equivalent
                forms of electronic communication, such as a mobile application&apos;s push
                notifications regarding updates or informative communications related to the
                functionalities, products or contracted services, including the security updates, when
                necessary or reasonable for their implementation.
              </li>
              <li>
                To provide You with news, special offers and general information about other goods,
                services and events which we offer that are similar to those that you have already
                purchased or enquired about unless You have opted not to receive such information.
              </li>
              <li>To manage Your requests: To attend and manage Your requests to Us.</li>
              <li>
                For business transfers: We may use Your information to evaluate or conduct a merger,
                divestiture, restructuring, reorganization, dissolution, or other sale or transfer of
                some or all of Our assets, whether as a going concern or as part of bankruptcy,
                liquidation, or similar proceeding, in which Personal Data held by Us about our
                Service users is among the assets transferred.
              </li>
              <li>
                For other purposes: We may use Your information for other purposes, such as data
                analysis, identifying usage trends, determining the effectiveness of our promotional
                campaigns and to evaluate and improve our Service, products, services, marketing and
                your experience.
              </li>
            </ul>

            <p className="mt-6 text-base leading-relaxed text-ink/80">
              We may share Your personal information in the following situations:
            </p>
            <ul className="mt-4 list-disc space-y-3 pl-6 text-base leading-relaxed text-ink/80">
              <li>
                With Service Providers: We may share Your personal information with Service Providers
                to monitor and analyze the use of our Service, to contact You.
              </li>
              <li>
                For business transfers: We may share or transfer Your personal information in connection
                with, or during negotiations of, any merger, sale of Company assets, financing, or
                acquisition of all or a portion of Our business to another company.
              </li>
              <li>
                With Affiliates: We may share Your information with Our affiliates, in which case we
                will require those affiliates to honor this Privacy Policy. Affiliates include Our
                parent company and any other subsidiaries, joint venture partners or other companies
                that We control or that are under common control with Us.
              </li>
              <li>
                With business partners: We may share Your information with Our business partners to
                offer You certain products, services or promotions.
              </li>
              <li>
                With other users: when You share personal information or otherwise interact in the
                public areas with other users, such information may be viewed by all users and may be
                publicly distributed outside.
              </li>
              <li>
                With Your consent: We may disclose Your personal information for any other purpose
                with Your consent.
              </li>
            </ul>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Retention of Your Personal Data
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                The Company will retain Your Personal Data only for as long as is necessary for the
                purposes set out in this Privacy Policy. We will retain and use Your Personal Data to
                the extent necessary to comply with our legal obligations (for example, if we are
                required to retain your data to comply with applicable laws), resolve disputes, and
                enforce our legal agreements and policies.
              </p>
              <p>
                The Company will also retain Usage Data for internal analysis purposes. Usage Data is
                generally retained for a shorter period of time, except when this data is used to
                strengthen the security or to improve the functionality of Our Service, or We are
                legally obligated to retain this data for longer time periods.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Transfer of Your Personal Data
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                Your information, including Personal Data, is processed at the Company&apos;s operating
                offices and in any other places where the parties involved in the processing are
                located. It means that this information may be transferred to — and maintained on —
                computers located outside of Your state, province, country or other governmental
                jurisdiction where the data protection laws may differ than those from Your
                jurisdiction.
              </p>
              <p>
                Your consent to this Privacy Policy followed by Your submission of such information
                represents Your agreement to that transfer.
              </p>
              <p>
                The Company will take all steps reasonably necessary to ensure that Your data is
                treated securely and in accordance with this Privacy Policy and no transfer of Your
                Personal Data will take place to an organization or a country unless there are
                adequate controls in place including the security of Your data and other personal
                information.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Disclosure of Your Personal Data
            </h2>

            <h3 className="mt-8 text-lg font-semibold text-ink">Business Transactions</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may
              be transferred. We will provide notice before Your Personal Data is transferred and
              becomes subject to a different Privacy Policy.
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Law enforcement</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              Under certain circumstances, the Company may be required to disclose Your Personal Data
              if required to do so by law or in response to valid requests by public authorities (e.g.
              a court or a government agency).
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Other legal requirements</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              The Company may disclose Your Personal Data in the good faith belief that such action is
              necessary to:
            </p>
            <ul className="mt-4 list-disc space-y-2 pl-6 text-base leading-relaxed text-ink/80">
              <li>Comply with a legal obligation</li>
              <li>Protect and defend the rights or property of the Company</li>
              <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
              <li>Protect the personal safety of Users of the Service or the public</li>
              <li>Protect against legal liability</li>
            </ul>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Security of Your Personal Data
            </h2>
            <p className="mt-6 text-base leading-relaxed text-ink/80">
              The security of Your Personal Data is important to Us, but remember that no method of
              transmission over the Internet, or method of electronic storage is 100% secure. While
              We strive to use commercially acceptable means to protect Your Personal Data, We cannot
              guarantee its absolute security.
            </p>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Children&apos;s Privacy
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                Our Service does not address anyone under the age of 13. We do not knowingly collect
                personally identifiable information from anyone under the age of 13. If You are a
                parent or guardian and You are aware that Your child has provided Us with Personal
                Data, please contact Us. If We become aware that We have collected Personal Data from
                anyone under the age of 13 without verification of parental consent, We take steps to
                remove that information from Our servers.
              </p>
              <p>
                If We need to rely on consent as a legal basis for processing Your information and Your
                country requires consent from a parent, We may require Your parent&apos;s consent
                before We collect and use that information.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Links to Other Websites
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                Our Service may contain links to other websites that are not operated by Us. If You
                click on a third party link, You will be directed to that third party&apos;s site. We
                strongly advise You to review the Privacy Policy of every site You visit.
              </p>
              <p>
                We have no control over and assume no responsibility for the content, privacy policies
                or practices of any third party sites or services.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Changes to this Privacy Policy
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                We may update Our Privacy Policy from time to time. We will notify You of any changes
                by posting the new Privacy Policy on this page.
              </p>
              <p>
                We will let You know via email and/or a prominent notice on Our Service, prior to the
                change becoming effective and update the &quot;Last updated&quot; date at the top of
                this Privacy Policy.
              </p>
              <p>
                You are advised to review this Privacy Policy periodically for any changes. Changes to
                this Privacy Policy are effective when they are posted on this page.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">Contact Us</h2>
            <p className="mt-6 text-base leading-relaxed text-ink/80">
              If you have any questions about this Privacy Policy, You can contact us:
            </p>
            <p className="mt-4 text-base leading-relaxed text-ink/80">
              <span className="font-semibold text-ink">By email:</span>{" "}
              <a
                href="mailto:info@altusonlineschool.com"
                className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
              >
                info@altusonlineschool.com
              </a>
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
